<template>
    <v-app>
        <menuDriver></menuDriver>
        <v-container fluid fill-height>
            <v-layout flex align-center justify-center>
                <v-flex xs12 sm6 elevation-6>
                    <v-card v-if="deliveryList.length == 0">
                        <v-card-text>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData" text-center>
                                <strong><font color="red" size="3">วันนี้ไม่สินค้าที่ต้องส่ง</font></strong>
                            </v-flex>
                        </v-card-text>
                    </v-card>
                    <v-card v-for="(item,i) in deliveryList" :key="i">
                        <v-card-text>
                            <v-layout>
                                <v-flex><font size="3"><strong>เลขที่ SO: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.soNo.toString()}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>รหัสร้านค้า: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.cardCode}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>ชื่อร้านค้า: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.cardName}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>โทรศัพท์: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.cardPhone}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>ชื่อลูกค้า: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.custName}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>โทรศัพท์: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.custTel}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>ที่อยู่ลูกค้า: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.custAddress}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>เวลาจัดส่ง: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.timeUpdate}}</font></v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>ถึงเมื่อ: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.timeStampStart}}</font>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex><font size="3"><strong>ออกเมื่อ: </strong></font></v-flex>
                                <v-flex xs8><font size="3">{{item.timeStampEnd}}</font></v-flex>
                            </v-layout>
                            <template v-if="item.timeUpdate">
                                <v-divider></v-divider>
                                <v-layout>
                                    <v-flex text-right>
                                        <v-btn large text fab @click="timeS(item)" color="warning" 
                                        :disabled="item.timeStampStart ? true : false">
                                            <v-icon>mdi-clock-check</v-icon>
                                            ถึง
                                        </v-btn>
                                    </v-flex>
                                    <v-flex>
                                        <v-btn large text fab @click="timeE(item)" color="success" 
                                        :disabled="item.timeStampEnd || !item.timeStampStart ? true : false">
                                            <v-icon>mdi-clock-check</v-icon>
                                            ออก
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- Dialog แจ้งเตือน ๆ -->
            <div>
                <!-- Dialog แจ้งยืนยันการลงเวลาเมื่อไปถึงแล้ว -->
                <v-dialog v-model="showWarningTimeS" :max-width="msgWarning.length*8" open-on-hover persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        {{msgWarning}}
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn text @click="confiTimeS" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn text color="red" @click="showWarningTimeS = false" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog แจ้งยืนยันการลงเวลาเมื่อส่งหรือประกอบสินค้าเสร็จแล้ว -->
                <v-dialog v-model="showWarningTimeE" :max-width="msgWarning.length*8" open-on-hover persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="yellow accent-4" :size="45">mdi-alert-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        {{msgWarning}}
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-layout>
                                    <v-flex text-right mr-1>
                                        <v-btn text @click="confiTimeE" color="green" dark>ตกลง</v-btn>
                                    </v-flex>
                                    <v-flex text-left ml-1>
                                        <v-btn text color="red" @click="showWarningTimeE = false" dark tabindex="-1">ยกเลิก</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog progress -->
                <v-dialog v-model="showDialogProgress" max-width="80" persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>

                <!-- Dialog Success -->
                <v-dialog v-model="showDialogSuccess" max-width="110" persistent>
                    <div class="text-center">
                        <v-card>
                            <v-card-text>
                                <v-layout>
                                    <v-flex>
                                        <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        บันทึกสำเร็จ!
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-dialog>
            </div>
        </v-container>
    </v-app>
</template>
<script>
import menuDriver from '@/components/menuDriver'
import {db} from '@/firebase'
export default {
    components:{
        menuDriver
    },
    data(){
        return{
            showDialogProgress: false,
            showDialogSuccess: false,
            showWarningTimeS: false,
            showWarningTimeE: false,
            msgWarning: '',
            searchData: false,
            noData: true,
            transNo: '',

            headerDelivery:[
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'soNo' },
                { text: 'รหัสร้านค้า', sortable: false, align: 'left', value: 'cardCode' },
                { text: 'ชื่อร้านค้า', sortable: false, align: 'left', value: 'cardName' },
                { text: 'โทรศัพท์', sortable: false, align: 'left', value: 'cardPhone' },
                { text: 'ชื่อลูกค้า', sortable: false, align: 'left', value: 'custName' },
                { text: 'โทรศัพท์', sortable: false, align: 'left', value: 'custTel' },
                { text: 'ที่อยู่ลูกค้า', sortable: false, align: 'left', value: 'custAddress' },
                { text: 'เวลาจัดส่ง', sortable: false, align: 'left', value: 'timeUpdate' },
                { text: 'ถึงเมื่อ', sortable: false, align: 'left', value: 'timeStampStart' },
                { text: 'ออกเมื่อ', sortable: false, align: 'left', value: 'timeStampEnd' },
            ],

            deliveryList: [],

            docId: '',
            timeStam: '',
            dateClose: '',
            trackId: '',
            trackDetail: [],
            trackTimelate: [],
        }
    },
    methods:{

        // ค้นหาตารางการจัดส่ง โดยค้นหาจากเลขที่ใบจัดส่ง
        getDeliveryList(){
            this.searchData = true
            this.noData = false
            let app = this
            let nowDate = new Date().toISOString().substr(0,10)
            db.collection("deliveryList").orderBy("time", "asc")
            .where("driverName", "==", sessionStorage.driver)
            .where("deliveryDate", "==", nowDate).get()
            .then(query=>{
                app.deliveryList = []
                let arr = []
                let i = 0
                query.forEach(doc=>{
                    arr.push({ ...doc.data(), id: query.docs[i].id })
                    i++
                })
                if(arr.length == 0){
                    this.searchData = false
                    this.noData = true
                }
                else{
                    arr.sort((a, b) => a.custName.localeCompare(b.custName))
                    let soId = []
                    let soNo = []
                    let cardCode = null
                    let cardName = null
                    let cardPhone = null
                    let custName = null
                    let custTel = null
                    let custAddress = null
                    let time = null
                    let timeUpdate = null
                    let timeStampStart = null
                    let timeStampEnd = null
                    let count = 0
                    arr.forEach(rec=>{
                        if(rec.custName != custName){
                            if(count > 0){
                                app.deliveryList.push({ soId: soId, soNo: soNo, cardCode: cardCode, cardName: cardName,
                                cardPhone: cardPhone, custName: custName, custTel: custTel, custAddress: custAddress, 
                                time: time, timeUpdate: timeUpdate, timeStampStart: timeStampStart, timeStampEnd: timeStampEnd })
                            }
                            if(rec.soNo){
                                soId = []
                                soId.push({ id: rec.id, soNo: rec.soNo })
                                soNo = []
                                soNo.push(rec.soNo)
                            }
                            else{
                                soId = []
                                soId.push({ id: rec.id, soNo: rec.rtNo })
                                soNo = []
                                soNo.push(rec.rtNo)
                            }
                            cardCode = rec.cardCode
                            cardName = rec.cardName
                            cardPhone = rec.cardPhone
                            custName = rec.custName
                            custTel = rec.custTel
                            custAddress = rec.custAddress
                            time = rec.time
                            timeUpdate = rec.timeUpdate
                            timeStampStart = rec.timeStampStart
                            timeStampEnd = rec.timeStampEnd
                            count = 1
                        }
                        else{
                            if(rec.soNo){
                                soId.push({ id: rec.id, soNo: rec.soNo })
                                soNo.push(rec.soNo)
                            }
                            else{
                                soId.push({ id: rec.id, soNo: rec.rtNo })
                                soNo.push(rec.rtNo)
                            }
                            count++
                        }
                    })
                    if(count > 0){
                        app.deliveryList.push({ soId: soId, soNo: soNo, cardCode: cardCode, cardName: cardName,
                        cardPhone: cardPhone, custName: custName, custTel: custTel, custAddress: custAddress, 
                        time: time, timeUpdate: timeUpdate, timeStampStart: timeStampStart, timeStampEnd: timeStampEnd })
                    }
                    app.deliveryList.sort((a, b) => a.timeUpdate.localeCompare(b.timeUpdate))
                }
            })
        },

        // แสดงข้อความยืนยันการลงเวลาเมื่อออกจากสถานที่ส่งสินค้าแล้ว
        timeS(item){
            let app = this
            this.showDialogProgress = true
            this.trackDetail = []
            this.timeStam = new Date().toTimeString().substr(0,5)
            this.msgWarning = "ถึงสถานที่ส่งสินค้า ณ เวลา " + this.timeStam + " น."
            let i = 0
            item.soId.forEach(el=>{
                db.collection("deliveryTimeline").where("trackNo", "==", el.soNo).get()
                .then(query=>{
                    app.trackDetail.push({ id: el.id, soNo: el.soNo, idTrack: '',
                    arr: [{ desc: "ถึงสถานที่ส่งสินค้า", icon: "mdi-truck-outline", time: app.timeStam }]})
                    let j = 0
                    query.forEach(doc=>{
                        doc.data().timeLine.forEach(rec=>{
                            app.trackDetail.forEach(a=>{
                                if(doc.data().trackNo == a.soNo){
                                    a.idTrack = query.docs[j].id
                                    a.arr.push(rec)
                                }
                            })
                        })
                    })
                    i++
                    callback()
                })
            })
            let callback = function
            callback(){
                if(i === item.soId.length){
                    // console.log(app.trackDetail)
                    app.showWarningTimeS = true
                    app.showDialogProgress = false
                }
            }
        },

        // บันทึกเวลาเมื่อถึงบ้านลูกค้า
        confiTimeS(){
            let app = this
            this.showDialogProgress = true
            app.trackDetail.forEach(rec=>{
                db.collection("deliveryList").doc(rec.id).update({
                    timeStampStart: app.timeStam,
                    timeStampStartBy: sessionStorage.driver
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(rec.idTrack).update({
                        timeLine: rec.arr
                    })
                    .then(()=>{
                        app.showDialogProgress = false
                        app.showDialogSuccess = true
                        setTimeout(() => {
                            app.showWarningTimeS = false
                            app.showDialogSuccess = false
                            app.getDeliveryList()
                        }, 2000)
                    })
                })
            })
        },

        // แสดงข้อความยืนยันการลงเวลาเมื่อไปถึงแล้ว
        timeE(item){
            let app = this
            this.showDialogProgress = true
            this.trackDetail = []
            this.trackTimelate = []
            this.timeStam = new Date().toTimeString().substr(0,5)
            let dayOne = new Date().setDate(new Date().getDate() + 1)
            let date = new Date(dayOne).toISOString().substr(0,10)
            let time = new Date(dayOne).toTimeString().substr(0,5)
            this.dateClose = date + " " + time
            this.msgWarning = "ออกจากสถานที่ส่งสินค้า ณ เวลา " + this.timeStam + " น."
            let i = 0
            item.soId.forEach(el=>{
                db.collection("deliveryTimeline").where("trackNo", "==", el.soNo).get()
                .then(query=>{
                    app.trackDetail.push({ id: el.id, soNo: el.soNo, idTrack: '',
                    arr: [{ desc: "จัดส่งสินค้าสำเร็จ", icon: "mdi-truck-check-outline", time: this.timeStam }]})
                    let j = 0
                    query.forEach(doc=>{
                        doc.data().timeLine.forEach(rec=>{
                            app.trackDetail.forEach(a=>{
                                if(doc.data().trackNo == a.soNo){
                                    a.idTrack = query.docs[j].id
                                    a.arr.push(rec)
                                }
                            })
                        })
                    })
                    i++
                    callback()
                })
            })
            let callback = function
            callback(){
                if(i === item.soId.length){
                    let lateTime = null
                    let start = null
                    let end = null
                    app.deliveryList.forEach(rec=>{
                        let nowDate = new Date().toISOString().substr(0,10)
                        let time = rec.time
                        if(time){
                            let splitTime = time.split(" - ")
                            if(!rec.timeStampEnd){
                                if(!lateTime){
                                    start = new Date(nowDate + " " + splitTime[1])
                                    end = new Date(nowDate + " " + app.timeStam)
                                    lateTime = end.getTime() - start.getTime()
                                }
                                if(rec.soNo != item.soNo){
                                    start = new Date(nowDate + " " + splitTime[0])
                                    end = new Date(nowDate + " " + splitTime[1])
                                    let lateStart = start.getTime() + lateTime
                                    let lateEnd = end.getTime() + lateTime
                                    app.trackTimelate.push({
                                        soId: rec.soId,
                                        soNo: rec.soNo,
                                        time: new Date(lateStart).toTimeString().substr(0,5) + " - " 
                                        + new Date(lateEnd).toTimeString().substr(0,5)
                                    })
                                }
                            }
                        }
                        
                    })
                    app.showWarningTimeE = true
                    app.showDialogProgress = false
                }
            }
        },

        // บันทึกเวลาเมื่อออกจากสถานที่ส่งสินค้าแล้ว
        confiTimeE(){
            let app = this
            this.showDialogProgress = true
            let i = 0
            app.trackDetail.forEach(rec=>{
                db.collection("deliveryList").doc(rec.id).update({
                    timeStampEnd: app.timeStam,
                    timeStampEndBy: sessionStorage.driver,
                })
                .then(()=>{
                    db.collection("deliveryTimeline").doc(rec.idTrack).update({
                        timeLine: rec.arr,
                        dateClose: app.dateClose
                    })
                    .then(()=>{
                        i++
                        callback()
                    })
                })
            })
            let callback = function
            callback(){
                if(i === app.trackDetail.length){
                    if(app.trackTimelate.length > 0){
                        let j = 0
                        app.trackTimelate.forEach(rec=>{
                            rec.soNo.forEach(soNo=>{
                                db.collection("deliveryTimeline").where("trackNo", "==", soNo).get()
                                .then(query=>{
                                    db.collection("deliveryTimeline").doc(query.docs[0].id).update({
                                        timeLine: [{ desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline", time: rec.time }]
                                    })
                                    .then(()=>{
                                        rec.soId.forEach(el=>{
                                            db.collection("deliveryList").doc(el.id).update({
                                                timeUpdate: rec.time
                                            })
                                            .then(()=>{
                                                j++
                                                callbackTrack()
                                            })
                                        })
                                    })
                                })
                            })
                        })
                        let callbackTrack = function
                        callbackTrack(){
                            if(j === app.trackTimelate.length){
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.showWarningTimeE = false
                                    app.showDialogSuccess = false
                                    app.getDeliveryList()
                                }, 2000)
                            }
                        }
                    }
                    else{
                        app.showDialogProgress = false
                        app.showDialogSuccess = true
                        setTimeout(() => {
                            app.showWarningTimeE = false
                            app.showDialogSuccess = false
                            app.getDeliveryList()
                        }, 2000)
                    }
                }
            }
        },

        // บันทึกเวลาเมื่อออกจากสถานที่ส่งสินค้าแล้ว
        confiTimeETest(){
            let app = this
            this.showDialogProgress = true
            db.collection("deliveryList").doc(app.docId).update({
                timeStampEnd: app.timeStam,
                timeStampEndBy: sessionStorage.driver,
            })
            .then(()=>{
                db.collection("deliveryTimeline").doc(app.trackId).update({
                    timeLine: app.trackDetail,
                    dateClose: app.dateClose
                })
                .then(()=>{
                    if(app.trackTimelate.length > 0){
                        let i = 0
                        app.trackTimelate.forEach(rec=>{
                            db.collection("deliveryTimeline").where("trackNo", "==", rec.soNo).get()
                            .then(query=>{
                                db.collection("deliveryTimeline").doc(query.docs[0].id).update({
                                    timeLine: [{ desc: "กำลังส่งสินค้า", icon: "mdi-truck-fast-outline", time: rec.time }]
                                })
                                .then(()=>{
                                    db.collection("deliveryList").where("soNo", "==", rec.soNo).get()
                                    .then(getId=>{
                                        db.collection("deliveryList").doc(getId.docs[0].id).update({
                                            timeUpdate: rec.time
                                        })
                                        .then(()=>{
                                            i++
                                            callback()
                                        })
                                    })
                                })
                            })
                        })
                        let callback = function
                        callback(){
                            if(app.trackTimelate.length === i){
                                app.showDialogProgress = false
                                app.showDialogSuccess = true
                                setTimeout(() => {
                                    app.showWarningTimeE = false
                                    app.showDialogSuccess = false
                                    app.getDeliveryList()
                                }, 2000)
                            }
                        }
                    }
                    else{
                        app.showDialogProgress = false
                        app.showDialogSuccess = true
                        setTimeout(() => {
                            app.showWarningTimeE = false
                            app.showDialogSuccess = false
                            app.getDeliveryList()
                        }, 2000)
                    }
                })
            })
        },
    },
    mounted(){
        if(sessionStorage.driver){
            this.getDeliveryList()
        }
    }
}
</script>